import { CustomLoadingOverlay as SharedLoadingOverlay } from '../../../../components/CustomLoadingOverlay';
import { CustomLoadingOverlayProps } from '../../../../types/components';
import { assets } from '../../assets';

export function CustomLoadingOverlay({ visible = true }: CustomLoadingOverlayProps) {
  return (
    <SharedLoadingOverlay visible={visible}>
      <assets.loader />
    </SharedLoadingOverlay>
  );
}
